<template>
  <div class="slider">
    <header-box :title="title"></header-box>
    <div class="slider__innerwrap">
      <div class="slider__comparator no-swipe-nav">

        <div class="slider__image" v-bind:style="{ backgroundImage: 'url(' + imageTop + ')' }">
          <span class="slider__label" v-html="labelTop"></span>
        </div>
        <div class="slider__view-limiter" v-bind:style="{ width: `${horizontalPercent}%`, height: `${verticalPercent}%` }">
          <div class="slider__image" v-bind:style="{
            backgroundImage: 'url(' + imageBottom + ')',
            width: `${10000/horizontalPercent}%`,
            height: `${10000/verticalPercent}%`
          }">
            <span class="slider__label slider__label--right" v-html="labelBottom"></span>
          </div> 
        </div>

        <div class="slider__dot" @touchmove="touchMove" v-bind:style="{right: + horizontalPercent + '%', bottom: + verticalPercent + '%'}"><span></span></div>

      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PrevNextNav from '@/components/PrevNextNav';
import HeaderBox from '@/components/HeaderBox';

export default {
  name: 'slider',
  components: { PrevNextNav, HeaderBox },
  data() {
    return {
      horizontalPercent: 50,
      verticalPercent: 50,
      isMouseDown: false,
      view: null,
      dot: null,
    };
  },
  computed: {
    ...mapGetters(['page']),
    title() {
      return this.page.title;
    },
    imageTop() {
      return this.page.imageTop;
    },
    imageBottom() {
      return this.page.imageBottom;
    },
    labelTop() {
      return this.page.labelTop;
    },
    labelBottom() {
      return this.page.labelBottom;
    },
  },
  mounted() {
    this.view = this.$el.querySelector('.slider__comparator');
    this.dot = this.$el.querySelector('.slider__dot');
    this.$el.addEventListener('mouseup', this.mouseUp);
    this.$el.addEventListener('mouseleave', this.mouseLeave);
    this.$el.addEventListener('mousemove', this.mouseMove);
    this.dot.addEventListener('mousedown', this.mouseDown);
  },
  methods: {
    width() {
      return this.view.offsetWidth;
    },
    height() {
      return this.view.offsetHeight;
    },
    right() {
      return this.view.getBoundingClientRect().right;
    },
    bottom() {
      return this.view.getBoundingClientRect().bottom;
    },
    mouseDown() {
      this.isMouseDown = true;
    },
    mouseUp() {
      this.isMouseDown = false;
    },
    mouseLeave() {
      this.isMouseDown = false;
    },
    mouseMove(event) {
      if (this.isMouseDown) {
        const horizontalPercentage = ((this.right() - event.clientX) / this.width());
        this.horizontalPercent = Math.max(Math.min(horizontalPercentage * 100, 100), 0);

        const verticalPercentage = ((this.bottom() - event.clientY) / this.height());
        this.verticalPercent = Math.max(Math.min(verticalPercentage * 100, 100), 0);
      }
    },
    touchMove(event) {
      // this.emitPercentage(event.touches[0].clientX);
      const horizontalPercentage = ((this.right() - event.touches[0].clientX) / this.width());
      this.horizontalPercent = Math.max(Math.min(horizontalPercentage * 100, 100), 0);

      const verticalPercentage = ((this.bottom() - event.touches[0].clientY) / this.height());
      this.verticalPercent = Math.max(Math.min(verticalPercentage * 100, 100), 0);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '../../scss/helpers';

.slider {
  @include page(true, true);

  &__innerwrap {
    display: flex;
    flex-direction: column;
    padding-bottom: 20px;

    @include not-mobile {
      padding-bottom: 40px;
      padding-top: 0;
    }

    @include landscape {
      padding-top: 20px;
      padding-bottom: 20px;
    }
  }

  &__comparator {
    width: 100%;
    display: block;
    background: $c_white;
    flex-grow: 1;
    border: 0;
    position: relative;

    // @include not-mobile {
    //   margin: 0 0 0 8.333%;
    //   width: 91.666%;
    // }

    // @include landscape {
    //   width: 100%;
    //   margin: 0;
    // }
  }

  &__image {
    display: block;
    background-size: cover;
    background-position: center;
    position: absolute;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;

    
    @media screen and (orientation: portrait) {
      width: 100% !important;
    }

    @media screen and (orientation: landscape) {
      height: 100% !important;
    }
  }

  &__label {
    @include font-block-title;
    background: $c_white;
    padding: 7px 20px 5px;
    position: absolute;
    bottom: 0;
    left: 0;

    @media screen and (orientation: portrait) {
      left: auto;
      right: 0;
      top: 0;
      bottom: auto;
    }

    &--right {
      left: auto;
      right: 0;

      @media screen and (orientation: portrait) {
        top: auto;
        bottom: 0;
      }
    }
  }

  &__view-limiter {
    position: absolute;
    bottom: 0;
    right: 0;
    height: 100%;
    width: 100%;
    overflow: hidden;

    @media screen and (orientation: portrait) {
      width: 100% !important;
    }

    @media screen and (orientation: landscape) {
      height: 100% !important;
    }
  }

  &__dot {
    width: 60px;
    height: 60px;
    position: absolute;
    bottom: 50%;
    transform: translate(50%, 50%);
    z-index: 1;
    border-radius: 50%;
    border: 30px solid transparent;

    @media screen and (orientation: portrait) {
      right: 50% !important;
    }

    @media screen and (orientation: landscape) {
      bottom: 50% !important;
    }
    
    &::before {
      content: '';
      display: block;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      background: $c_primary;
      box-shadow: 0px 2px 2px 0px rgba(0,0,0,0.31);
    }

    span {
      width: 20px;
      height: 20px;
      position: absolute;
      top: calc(50% - 10px);
      left: calc(50% - 10px);
      transform: rotate(-45deg);

      @media screen and (orientation: portrait) {
        transform: rotate(45deg);
      }

      &::before,
      &::after {
        content: '';
        display: block;
        width: 10px;
        height: 10px;
        border: 3px solid $c_white;
        box-sizing: border-box;
        position: absolute;
      }

      &::before {
        border-right: none;
        border-bottom: none;
        top: 0;
        left: 0;
      }

      &::after {
        border-left: none;
        border-top: none;
        bottom: 0;
        right: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/templates/Slider.vue